/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import { useNavigate } from "react-router-dom";

import NavCard from "./nav-card";

import useScreenSize from "@/hooks/useScreenSize";
import {
  consultancy,
  creative,
  financialConsultancy,
  manageServices,
  projectManagement,
  services,
  techServices,
  humanCapitalDevelopment,
} from "@/assets/data/navbar";

export default function ServiceNavCard() {
  const navigate = useNavigate();
  const isMdScreen = useScreenSize("md");

  if (isMdScreen) {
    return (
      <ul className="">
        {services.map((listItem) => (
          <li
            key={listItem.label}
            className="px-5 py-2.5 cursor-pointer"
            onClick={() => navigate(listItem.link)}
          >
            {listItem.label}
          </li>
        ))}
      </ul>
    );
  }

  return (
    <NavCard>
      <div className="grid md:grid-cols-3 gap-10">
        <NavCard.ListItem
          link={consultancy.link}
          list={consultancy.list}
          list2={consultancy.list2}
          title={consultancy.title}
        />
        <NavCard.ListItem
          link={humanCapitalDevelopment.link}
          list={humanCapitalDevelopment.list}
          list2={humanCapitalDevelopment.list2}
          title={humanCapitalDevelopment.title}
        />
        <NavCard.ListItem
          link={techServices.link}
          list={techServices.list}
          list2={techServices.list2}
          title={techServices.title}
        />
      </div>
      <div className="grid md:grid-cols-4 gap-12 mt-[60px]">
        <NavCard.ListItem
          link={projectManagement.link}
          list={projectManagement.list}
          title={projectManagement.title}
        />
        <NavCard.ListItem
          link={manageServices.link}
          list={manageServices.list}
          title={manageServices.title}
        />
        <NavCard.ListItem
          link={creative.link}
          list={creative.list}
          title={creative.title}
        />
        <NavCard.ListItem
          link={financialConsultancy.link}
          list={financialConsultancy.list}
          title={financialConsultancy.title}
        />
      </div>
    </NavCard>
  );
}
